import PeopleIcon from "@mui/icons-material/People";
import GroupsIcon from "@mui/icons-material/Groups";
import BarChartIcon from "@mui/icons-material/BarChart";
import HistoryIcon from "@mui/icons-material/History";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import type { SvgIconComponent } from "@mui/icons-material";
import type { Summary } from "@api/statistics.api";

/** Accent used in hero stats and matching feature tiles. */
export const HOME_ACCENT = {
  players: "#3B82F6",
  teams: "#10B981",
  statistics: "#F59E0B",
  history: "#8B5CF6",
} as const;

export interface HomeFeatureCardDef {
  icon: SvgIconComponent;
  i18nTitle: string;
  i18nDesc: string;
  path: string;
  color: string;
}

export const HOME_FEATURE_CARDS: HomeFeatureCardDef[] = [
  {
    icon: PeopleIcon,
    i18nTitle: "home.features.players",
    i18nDesc: "home.features.playersDesc",
    path: "/players",
    color: HOME_ACCENT.players,
  },
  {
    icon: GroupsIcon,
    i18nTitle: "home.features.teams",
    i18nDesc: "home.features.teamsDesc",
    path: "/teams",
    color: HOME_ACCENT.teams,
  },
  {
    icon: BarChartIcon,
    i18nTitle: "home.features.statistics",
    i18nDesc: "home.features.statisticsDesc",
    path: "/statistics",
    color: HOME_ACCENT.statistics,
  },
  {
    icon: HistoryIcon,
    i18nTitle: "home.features.history",
    i18nDesc: "home.features.historyDesc",
    path: "/history",
    color: HOME_ACCENT.history,
  },
];

export interface HomeStatBadgeDef {
  icon: SvgIconComponent;
  labelKey:
    | "home.stats.totalPlayers"
    | "home.stats.totalMatches"
    | "home.stats.totalGoals"
    | "home.stats.goalsPerMatch";
  getValue: (s: Summary) => string | number;
  color: string;
}

export const HOME_STAT_BADGES: HomeStatBadgeDef[] = [
  {
    icon: PeopleIcon,
    labelKey: "home.stats.totalPlayers",
    getValue: (s) => s.totalPlayers,
    color: HOME_ACCENT.players,
  },
  {
    icon: SportsSoccerIcon,
    labelKey: "home.stats.totalMatches",
    getValue: (s) => s.totalMatches,
    color: HOME_ACCENT.teams,
  },
  {
    icon: EmojiEventsIcon,
    labelKey: "home.stats.totalGoals",
    getValue: (s) => s.totalGoals,
    color: HOME_ACCENT.statistics,
  },
  {
    icon: BarChartIcon,
    labelKey: "home.stats.goalsPerMatch",
    getValue: (s) => s.goalsPerMatch,
    color: HOME_ACCENT.history,
  },
];
